import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './reducers';
import thunk from 'redux-thunk';
import * as Sentry from '@sentry/react';
import tokenRefreshMiddleware from './middleware/tokenRefreshMiddleware';
import trackingMiddleware from './middleware/trackingMiddleware';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  actionTransformer: (action) => {
    return { type: action.type };
  }
});

export default function configureStore() {
  const finalCreateStore = compose(
    applyMiddleware(thunk, tokenRefreshMiddleware, trackingMiddleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f,
    sentryReduxEnhancer
  )(createStore);

  const store = finalCreateStore(rootReducer);
  if (import.meta.hot) {
    import.meta.hot.accept('./reducers', () => store.replaceReducer(require('./reducers')));
  }

  return store;
}
